import { Empty } from "antd";
import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useAxisLabelFontStyle } from "../../../Utlis/CharStyle";
import GraphLayout from "../../GraphLayout";

const DEFAULT_COLOURS = [
  "#4F46E5",
  "#F59E0B",
  "#16A34A",
  "#EA580C",
  "#0EA5E9",
  "#DB2777",
  "#7C3AED",
  "#14B8A6",
  "#FB3748",
  "#84CC16",
];

// graphData takes the same `{ labels, <seriesKey>: [...] }` shape as the
// other charts, but a pie can only plot one series -- only the first key
// after `labels` is drawn.
const PieChart = ({
  graphData,
  colourTheme = DEFAULT_COLOURS,
  graphTitle = "Undefined",
  classNameCSS,
  unit = "",
}) => {
  const { axisLabelFontStyle, chartRef } = useAxisLabelFontStyle();
  const [filteredLabels, setFilteredLabels] = useState([]);
  const [series, setSeries] = useState([]);

  if (!graphData?.labels?.length) {
    return (
      <GraphLayout
        title={graphTitle}
        data={graphData || { labels: [] }}
        setFilteredLabels={setFilteredLabels}
        series={series}
        setSeries={setSeries}
        selectAllByDefault
        colourTheme={colourTheme}
        classNameCSS={classNameCSS}
      >
        <Empty
          style={{
            height: "300px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
          description={
            <span style={{ color: "#FB3748" }}>
              {`No ${graphTitle} data available`}
            </span>
          }
        />
      </GraphLayout>
    );
  }

  const formatValue = (val) => {
    if (val === undefined || val === null) return "";
    if (unit === "$") return `${unit} ${Number(val).toFixed(2)}`;
    return unit ? `${val} ${unit}` : `${val}`;
  };

  const options = {
    chart: {
      type: "pie",
      height: 300,
      toolbar: {
        show: false,
      },
    },
    labels: filteredLabels,
    colors: colourTheme,
    dataLabels: {
      enabled: true,
      formatter: (percent) => `${percent.toFixed(1)}%`,
      dropShadow: {
        enabled: false,
      },
    },
    legend: {
      show: true,
      position: "bottom",
      fontFamily: axisLabelFontStyle.fontFamily,
      fontSize: axisLabelFontStyle.fontSize,
      labels: {
        colors: axisLabelFontStyle.colors,
      },
    },
    stroke: {
      width: 1,
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: formatValue,
      },
    },
  };

  return (
    <GraphLayout
      title={graphTitle}
      data={graphData}
      setFilteredLabels={setFilteredLabels}
      series={series}
      setSeries={setSeries}
      selectAllByDefault
      colourTheme={colourTheme}
      classNameCSS={classNameCSS}
    >
      <div ref={chartRef}>
        <ReactApexChart
          height={300}
          options={options}
          series={series[0]?.data || []}
          type="pie"
        />
      </div>
    </GraphLayout>
  );
};

export default PieChart;
